import React from "react";

const AdBanner = ({ imageSrc, altText, companyName, link, className = "" }) => {
  return (
    <div className={`ad-banner ${className}`}>
      <a href={link} target="_blank" rel="noopener noreferrer" className="ad-link">
        <img src={imageSrc} alt={altText} className="ad-image" />
        <div className="ad-overlay">
          <span className="ad-label">Reklam</span>
          <span className="ad-company">{companyName}</span>
        </div>
      </a>
    </div>
  );
};

export default AdBanner;

